const localizers = {
  'Alerts.noAlerts.txt': () => `Não foram definidos alertas para este relatório.`,
  'BirdImage.image.txt': () => `Imagem`,
  'ComboBox.clearFilter.txt': () => `Limpar filtro`,
  'ComboBox.defautValueNoData.fmt': ({categoryValue}) => `${categoryValue} (Sem Dados)`,
  'ContextMenu.selectAll.txt': () => `Selecionar tudo`,
  'ContextMenu.clearSelection.txt': () => `Limpar Seleção`,
  'ContextMenu.exportImage.txt': () => `Exportar como Imagem`,
  'ContextMenu.sortAscending.fmt': ({role}) => `${role}: ascendente`,
  'ContextMenu.sortDescending.fmt': ({role}) => `${role}: descendente`,
  'ContextMenu.sortAddAscending.fmt': ({role}) => `${role}: adicionar ascendente`,
  'ContextMenu.sortAddDescending.fmt': ({role}) => `${role}: adicionar descendente`,
  'ContextMenu.removeSortItem.fmt': ({role}) => `Remover ${role} da ordenação`,
  'ContextMenu.removeSortLevel.txt': () => `Remover nível de ordenação`,
  'ContextMenu.sort.txt': () => `Ordenar`,
  'ContextMenu.selectShortestPath.txt': () => `Selecionar caminho mais curto`,
  'ContextMenu.explain.txt': () => `Explicar dados`,
  'ContextMenu.explainRole.txt': ({role}) => `Explicar ${role}...`,
  'ContextMenu.manageColumns.txt': () => `Gerir colunas`,
  'ContextMenu.includeMissingValues.txt': () => `Incluir valores em falta`,
  'DrillableTooltip.drill.txt': () => `DESAGREGAR`,
  'DrillableTooltip.tooltip.txt': () => `DESCRIÇÃO`,
  'DrillableTooltip.links.txt': () => `LIGAÇÕES`,
  'DrillableTooltip.section.link.fmt': ({page}) => `Ligação de Página para ${page}`,
  'DrillableTooltip.report.link.fmt': ({report}) => `Ligação de Relatório para ${report}`,
  'DrillableTooltip.external.link.fmt': ({url}) => `Ligação Externa para ${url}`,
  'DrillableTooltip.notAvailable.txt': () => `Indisponível`,
  'Breadcrumb.all.fmt': ({label}) => `Todos os ${label}`,
  'BrowserCheck.title.txt': () => `Verificação de WebGL`,
  'BrowserCheck.msg.txt': () => `O WebGL está desativado ou não é suportado pelo seu browser.   \nClique em OK para ver o relatório no visualizador clássico.`,
  'EmailUtil.subject.multiple.txt': () => `Relatórios para revisão`,
  'EmailUtil.tooLongEmail.txt': () => `O limite do comprimento de e-mail foi excedido. Selecione menos relatórios a enviar por e-mail.`,
  'HiddenSectionDialog.close.txt': () => `Fechar`,
  'HiddenSectionDialog.export.txt': () => `Exportar como formato PDF`,
  'InfoPanel.information.txt': () => `Informação`,
  'InfoPanel.comments.txt': () => `Comentários`,
  'InfoPanel.alerts.txt': () => `Alertas`,
  'IncomingFilters.promptbars.txt': () => `Barras de Prompt`,
  'Information.title.txt': () => `Título`,
  'Information.name.txt': () => `Nome:`,
  'Information.description.txt': () => `Descrição:`,
  'Information.displayRules.txt': () => `Regras de apresentação:`,
  'Information.graphLevel.txt': () => `Nível de Gráfico`,
  'Information.reportLevel.txt': () => `Nível de Relatório`,
  'Information.legend.txt': () => `Legenda`,
  'Information.incomingFilters.txt': () => `Filtros de entrada:`,
  'Information.noIncomingFilters.txt': () => `Sem Filtros de Entrada`,
  'Information.dataSourceFilters.txt': () => `Filtros de fonte de dados:`,
  'Information.interactiveFilters.txt': () => `Filtros interativos:`,
  'MobileContainer.mobileBIMessage.txt': () => `Aceda a relatórios SAS no seu dispositivo móvel.`,
  'ObjectTypes.report.txt': () => `Relatório`,
  'ObjectTypes.Report.BI.txt': () => `Relatório SAS (2G)`,
  'ObjectTypes.Report.StoredProcess.txt': () => `Stored process report`,
  'ObjectTypes.StoredProcess.txt': () => `Stored process`,
  'MissingValues.label.txt': () => `(valores em falta)`,
  'PromptContainer.apply.txt': () => `OK`,
  'PromptContainer.cancel.txt': () => `Cancelar`,
  'PromptContainer.close.txt': () => `Fechar`,
  'TextFieldTypeAhead.validation.range.fmt': ({min, max}) => `O valor deve ser um número entre ${min} e ${max}, inclusive.`,
  'TextFieldTypeAhead.validation.numeric.txt': () => `Especifique um valor numérico válido.`,
  'TextFieldTypeAhead.validation.string.txt': () => `O valor não é válido para os dados atribuídos.`,
  'TextFieldTypeAhead.categoryAndMeasureTooltip.fmt': ({categoryLabel, measureLabel}) => `Introduza: ${categoryLabel}, ${measureLabel}`,
  'TextFieldTypeAhead.categoryTooltip.fmt': ({categoryLabel}) => `Introduza: ${categoryLabel}`,
  'TextFieldTypeAhead.placeholder.fmt': ({placeholderLabel}) => `Introduza ${placeholderLabel}...`,
  'RangeSlider.tooltip.fmt': ({label, min, max}) => `${label}: ${min} - ${max}`,
  'Slider.missingValues.txt': () => `Valores em falta`,
  'PromptElement.categoryLabelValueAndMeasureLabelValueTooltip.fmt': ({categoryLabel, categoryValue, measureLabel, measureValue}) => `${categoryLabel}: ${categoryValue}, ${measureLabel}: ${measureValue}`,
  'PromptElement.categoryLabelValueTooltip.fmt': ({categoryLabel, categoryValue}) => `${categoryLabel}: ${categoryValue}`,
  'ReportContainer.back.txt': () => `Voltar`,
  'ReportContainer.reportCorrupted.txt': () => `RELATÓRIO DANIFICADO`,
  'ReportContainer.themeLoadFailed.txt': () => `Falha ao carregar tema de relatório.`,
  'ReportContainer.restoreButton.tip.txt': () => `Restaurar relatório`,
  'ReportContainer.restoreButtonAriaAnnounce.txt': () => `Relatório restaurado`,
  'ReportContainer.renderError.txt': () => `Ocorreu um erro. Não foi possível apresentar o relatório.`,
  'ReportContainer.component.renderError.txt': () => `Ocorreu um erro. Não foi possível compor o componente.`,
  'ReportContentPage.open.txt': () => `Abrir...`,
  'ReportContentPage.refreshReport.txt': () => `Atualizar relatório`,
  'ReportContentPage.editReport.txt': () => `Editar relatório`,
  'ReportContentPage.print.txt': () => `Imprimir...`,
  'ReportContentPage.email.txt': () => `E-mail...`,
  'ReportContentPage.export.txt': () => `Exportar para Excel...`,
  'ReportContentPage.reportProperties.txt': () => `Propriedades do Relatório`,
  'ReportContentPage.shareReport.txt': () => `Partilhar relatório`,
  'ReportContentPage.enableOverlays.txt': () => `Ativar sobreposições de objetos`,
  'ReportContentPage.disableOverlays.txt': () => `Desativar sobreposições de objetos`,
  'ReportContentPage.link.txt': () => `Ligação...`,
  'ReportContentPage.settings.txt': () => `Definições...`,
  'ReportContentPage.editPlayback.txt': () => `Editar reprodução`,
  'ReportContentPage.playReport.txt': () => `Reproduzir relatório`,
  'ReportContentPage.showFiltersButton.tip.txt': () => `Mostrar filtros pedidos`,
  'ReportContentPage.hideFiltersButton.tip.txt': () => `Ocultar filtros pedidos`,
  'ReportContentPage.reportFilters.txt': () => `Nível de relatório`,
  'ReportContentPage.pageFilters.txt': () => `Nível de página`,
  'ReportContentPage.refreshRequired.txt': () => `É necessário atualizar o relatório`,
  'ReportContentPage.infoButton.tip.txt': () => `Painel de Informação`,
  'ReportContentPage.backButton.tip.txt': () => `Ver todos os relatórios`,
  'ReportContentPage.overflowMenuButton.tip.txt': () => `Mais opções`,
  'ReportContentPage.itemGroupName.txt': () => `Relatórios`,
  'ReportContentPage.maximizeButton.tip.txt': () => `Maximizar relatório`,
  'ReportContentPage.closeButton.txt': () => `Fechar relatório`,
  'ReportContentPage.maximizeButtonAriaAnnounce.txt': () => `Relatório maximizado`,
  'ReportContentPage.resetReportState.txt': () => `Restaurar predefinido estado do relatório`,
  'ReportContentPage.summary.txt': () => `Mostrar resumo`,
  'ReportManagerPage.objectMenu.open.txt': () => `Abrir`,
  'ReportManagerPage.objectMenu.edit.txt': () => `Editar`,
  'ReportManagerPage.objectMenu.summary.txt': () => `Resumo`,
  'ReportManagerPage.objectMenu.properties.txt': () => `Propriedades`,
  'ReportManagerPage.objectMenu.email.txt': () => `E-mail...`,
  'ReportManagerPage.objectMenu.print.txt': () => `Imprimir`,
  'ReportManagerPage.browseReportsButton.txt': () => `Procurar nos relatórios`,
  'ReportManagerPage.newReportButton.txt': () => `Novo relatório`,
  'ReportManagerPage.emptyView.message.txt': () => `Nenhuns relatórios encontrados.`,
  'ReportManagerPage.emptyView.browseReportsButton.txt': () => `Procurar Relatórios`,
  'ReportManagerPage.tableView.name.txt': () => `Nome`,
  'ReportManagerPage.tableView.author.txt': () => `Autor`,
  'ReportManagerPage.tableView.lastModified.txt': () => `Última Modificação`,
  'ReportManagerPage.openButton.tip.txt': () => `Abrir relatório`,
  'ReportManagerPage.emailButton.tip.txt': () => `Enviar relatório por e-mail`,
  'ReportManagerPage.printButton.tip.txt': () => `Imprimir relatório como PDF`,
  'ReportManagerPage.propertiesButton.tip.txt': () => `Propriedades do relatório`,
  'ReportObject.multipleReferences.error.txt': () => `Os objetos de relatório não podem ser usados em mais do que um contexto.`,
  'ReportObject.notFound.error.txt': () => `O nome de objeto não foi encontrado no relatório especificado.`,
  'ReportObject.invalidPage.error.txt': () => `A página especificada não é válida.`,
  'ReportPropertiesDialog.open.txt': () => `Abrir`,
  'ReportPropertiesDialog.close.txt': () => `Fechar`,
  'ReportPropertiesDialog.name.txt': () => `Nome:`,
  'ReportPropertiesDialog.description.txt': () => `Descrição:`,
  'ReportPropertiesDialog.keywords.txt': () => `Palavras-chave:`,
  'ReportPropertiesDialog.type.txt': () => `Tipo:`,
  'ReportPropertiesDialog.location.txt': () => `Localização:`,
  'ReportPropertiesDialog.createdBy.txt': () => `Criado por:`,
  'ReportPropertiesDialog.dateCreated.txt': () => `Data de criação:`,
  'ReportPropertiesDialog.modifiedBy.txt': () => `Modificado por:`,
  'ReportPropertiesDialog.dateModified.txt': () => `Data de modificação:`,
  'ReportSections.newPageButton.txt': () => `Nova página`,
  'ReportSections.closeTab.tooltip.txt': () => `Eliminar página`,
  'ReportSections.menuButton.tooltip.fmt': ({label}) => `Menu ${label}`,
  'ReportSummaryDialog.title.txt': () => `Resumo`,
  'ReportSummaryDialog.open.txt': () => `Abrir`,
  'ReportSummaryDialog.cancel.txt': () => `Cancelar`,
  'ReportSummaryDialog.close.txt': () => `Fechar`,
  'ReportSummaryDialog.noSummary.txt': () => `Nenhum sumário está disponível.`,
  'ReportTileBody.modifiedBy.txt': () => `Modificado por:`,
  'ReportTileBody.lastModified.txt': () => `Última modificação:`,
  'VAViewerSettingsProvider.reportViewer.txt': () => `SAS Report Viewer`,
  'VAViewerSettingsProvider.reportRefreshSettings.txt': () => `Atualizar Relatório`,
  'VAViewerSettingsProvider.reportAutoRefresh.txt': () => `Atualização de Relatório Automática`,
  'VAViewerSettingsProvider.reportRefreshFrequency.txt': () => `Verificar existência de atualizações após este número de minutos:`,
  'VAViewerSettingsProvider.alert.group.label.txt': () => `Notificações de Alerta`,
  'VAViewerSettingsProvider.alert.field.label.txt': () => `Selecione as notificações de alerta predefinidas:`,
  'VAViewerSettingsProvider.alert.email.txt': () => `Enviar mensagens de e-mail`,
  'VAViewerSettingsProvider.alert.sms.txt': () => `Enviar mensagens SMS`,
  'VAViewerSettingsProvider.alert.system.txt': () => `Predefinição do administrador`,
  'VAViewerSettingsProvider.generalSettings.txt': () => `Temas`,
  'VAViewerSettingsProvider.enableHighContrast.txt': () => `Substituir o tema de relatório e utilizar o tema de relatório SAS High Contrast`,
  'ViewerBusyDialog.openReport.txt': () => `A abrir relatório...`,
  'ViewerBusyDialog.prepareExport.txt': () => `A preparar exportação...`,
  'ViewerBusyDialog.preparePrint.txt': () => `A preparar para imprimir...`,
  'PDFGeneration.printingReport.txt': () => `A gerar relatório PDF. Será transferido quando estiver pronto.`,
  'PDFGeneration.fileName.fmt': ({fileName, date}) => `${fileName} em ${date}`,
  'VisualElementActionUtil.actionMenuLabel.txt': () => `Selecionar uma ação`,
  'VisualElementActionUtil.hierarchyExhausted.txt': () => `Atingiu o nível mais baixo da hierarquia.`,
  'VisualElementActionUtil.hierarchiesExhausted.txt': () => `Atingiu o nível mais baixo de todas as hierarquias.`,
  'VisualElementActionUtil.drillLabel.fmt': ({value}) => `Explorar ${value}`,
  'SaveImageUtil.snapshot.fmt': ({a0, a1, a2}) => `Instantâneo de ${a0} ${a1} às ${a2}`,
  'ObjectToolbarIcon.SaveImageTooltip.txt': () => `Guardar imagem`,
  'ObjectToolbarIcon.PrintObject.txt': () => `Imprimir objeto...`,
  'ObjectToolbarIcon.ShareObject.txt': () => `Partilhar objeto...`,
  'ObjectToolbarIcon.OverflowButton.default.txt': () => `Mais`,
  'ObjectToolbarIcon.OverflowButton.labeled.fmt': ({label}) => `Menu de objeto para ${label}`,
  'ObjectToolbarIcon.Accelerator.txt': () => `Ver com o SAS® Graphics Accelerator`,
  'ZoomControl.button.tip.txt': () => `Zoom`,
  'ZoomControl.button.zoomin.txt': () => `Ampliar`,
  'ZoomControl.button.zoomout.txt': () => `Afastar`,
  'ZoomControl.button.display.txt': () => `Controlos de Zoom`,
  'ZoomControl.button.reset.txt': () => `Repor zoom`,
  'ExpandControl.button.expand.txt': () => `Maximizar vista`,
  'ExpandControl.button.restore.txt': () => `Restaurar vista`,
  'ExpandControl.button.expand.tip.txt': () => `Maximizar`,
  'ExpandControl.button.restore.tip.txt': () => `Restaurar`,
  'ReportVisualContainer.sectionLink.notAllowed.maximize.txt': () => `Não é possível executar ligações de página enquanto este objeto estiver maximizado.`,
  'DragModeControl.button.pan.tip.txt': () => `Deslocar`,
  'DragModeControl.button.circular.tip.txt': () => `Seleção circular`,
  'DragModeControl.button.freeform.tip.txt': () => `Seleção de forma livre`,
  'DragModeControl.button.rectangular.tip.txt': () => `Seleção Retangular`,
  'DragModeControl.button.zoom.tip.txt': () => `Ampliar retângulo`,
  'ReportXMLDialog.title.txt': () => `XML do Relatório`,
  'ReportXMLDialog.closeButton.txt': () => `Fechar`,
  'ReportXMLDialog.copyButton.txt': () => `Copiar para a Área de Transferência`,
  'ReportXMLDialog.error.txt': () => `Erro ao carregar o XML do relatório`,
  'ErrorDialog.error.txt': () => `Ocorreu um erro. Contacte o administrador do sistema.`,
  'Application.banner.txt': () => `SAS® Report Viewer`,
  'Application.wip.banner.txt': () => `SAS® Visual Analytics - Report Viewer`,
  'Application.productName.txt': () => `SAS® Visual Analytics`,
  'OpenReportDialog.title.txt': () => `Abrir Relatório`,
  'OpenReportDialog.reports.txt': () => `Relatórios:`,
  'OpenReportDialog.cancel.txt': () => `Cancelar`,
  'OpenReportDialog.ok.txt': () => `OK`,
  'AriaLive.numberOfObjectsUpdated.fmt': ({count}) => `${count} objetos atualizados`,
  'AriaLive.oneObjectUpdated.txt': () => `1 objeto atualizado`,
  'AriaLive.reportOpened.txt': () => `Relatório aberto`,
  'AriaLive.reportClosed.txt': () => `Relatório fechado`,
  'ExportData.generating.txt': () => `A gerar exportação. Será transferido quando estiver pronto.`,
  'ExportData.warning.txt': () => `Erro ao gerar dados`,
  'ExportData.nodata.txt': () => `Sem dados para exportar`,
  'ExportData.exportData.txt': () => `Exportar dados...`,
  'PlaybackAnimationDialog.saveButton.txt': () => `Guardar`,
  'PlaybackAnimationDialog.cancelButton.txt': () => `Cancelar`,
  'PlaybackAnimationDialog.playButton.txt': () => `Reproduzir relatório`,
  'PlaybackAnimationDialog.title.txt': () => `Editar Reprodução`,
  'PlaybackAnimationDialog.transitionUnit.label.txt': () => `Unidade de transição:`,
  'PlaybackAnimationDialog.transitionUnit.page.txt': () => `Página`,
  'PlaybackAnimationDialog.transitionUnit.object.txt': () => `Objeto`,
  'PlaybackAnimationDialog.secondsPerUnit.label.txt': () => `Segundos por unidade:`,
  'PlaybackAnimationDialog.showMaximized.label.txt': () => `Mostrar objetos maximizados:`,
  'PlaybackAnimationDialog.showCanvasOnly.label.txt': () => `Mostrar apenas tela:`,
  'PlaybackAnimationDialog.showTimer.label.txt': () => `Mostrar temporizador:`,
  'PlaybackAnimationDialog.showNavigationControls.label.txt': () => `Mostrar controlos de navegação quando se clica ou toca:`,
  'PlaybackNavigationControls.previousPage.txt': () => `Página anterior`,
  'PlaybackNavigationControls.nextPage.txt': () => `Página seguinte`,
  'PlaybackNavigationControls.previousObject.txt': () => `Objeto anterior`,
  'PlaybackNavigationControls.nextObject.txt': () => `Objeto seguinte`,
  'TransportConnection.generateReportTimeout.txt': () => `O relatório está a demorar tempo a mais para ser carregado. Pretende continuar?`,
  'TransportConnection.openReport.txt': () => `Abrir Relatório`,
  'ViewerContainer.reportNotFound.fmt': ({location}) => `O relatório especificado na seguinte localização não existe: ${location}`,
  'Hierarchy.expand.fmt': ({label}) => `Expandir ${label}`,
  'Hierarchy.collapse.fmt': ({label}) => `Fechar ${label}`,
  'GraphElementDecorator.overview.txt': () => `Visão geral`,
  'GraphElementDecorator.layers.txt': () => `Ocultar ou mostrar camadas`,
  'CompositeGraphElementDecorator.hideOverview.txt': () => `Ocultar Visão Geral`,
  'CompositeGraphElementDecorator.showOverview.txt': () => `Mostrar Visão Geral`,
  'TitleInfoButton.tooltip.txt': () => `Informação`,
  'SectionSelectionBar.noSelections.txt': () => `Nada selecionado`,
  'SectionSelectionBar.title.txt': () => `Filtros:`,
  'CheckboxList.selectAll.txt': () => `Selecionar tudo`,
  'CheckboxList.clearSelection.txt': () => `Limpar Seleção`,
  'CheckboxList.clearSelection.fmt': ({count}) => `Limpar seleção (${count})`,
  'ExplanationInfoDialog.title.fmt': ({label}) => `Explicar ${label}`,
  'ExplanationInfoDialog.loading.txt': () => `A preparar explicação...`,
  'ExplanationInfoDialog.cancel.txt': () => `Cancelar`,
  'ExplanationInfoDialog.close.txt': () => `Fechar`,
  'PromptHeader.emptyReport.txt': () => `Arraste um item de dados ou controlo para aqui para criar um prompt de relatório.`,
  'PromptHeader.emptyPage.txt': () => `Arraste um item de dados ou controlo para aqui para criar um prompt de página.`,
  'PromptHeader.collapsePageControlArea.txt': () => `Fechar zona de controlo de página`,
  'PromptHeader.expandPageControlArea.txt': () => `Expandir zona de controlo de página`,
  'PromptHeader.collapseReportControlArea.txt': () => `Fechar zona de controlo de relatório`,
  'PromptHeader.expandReportControlArea.txt': () => `Expandir zona de controlo de relatório`,
  'PromptHeader.collapseControlArea.txt': () => `Fechar zona de controlo`,
  'PromptHeader.expandControlArea.txt': () => `Expandir zona de controlo`,
  'PromptHeader.reportControlArea.txt': () => `Zona de controlo de relatório`,
  'PromptHeader.allControlAreas.txt': () => `Todas as zonas de controlo`,
  'PromptHeader.pageControlArea.txt': () => `Zona de controlo de página`,
  'ZeroState.editMode.txt': () => `Arraste um template, itens de dados ou objetos para aqui.`,
  'ZeroState.viewMode.txt': () => `Não existe conteúdo para apresentar.`,
  'ObjectStatus.assignData.txt': () => `Atribuir dados`,
  'ObjectStatus.selectImage.txt': () => `Selecionar imagem`,
  'ObjectStatus.selectJob.txt': () => `Selecione tarefa`,
  'ObjectStatus.cancelLoading.txt': () => `Cancelar carregamento`,
  'ObjectStatus.loadingCanceled.txt': () => `Carregamento cancelado`,
  'ObjectStatus.resumeLoading.txt': () => `Retomar carregamento`,
  'ObjectStatus.refresh.txt': () => `Atualizar`,
  'ObjectStatus.setJobParameters.txt': () => `Definir valores de parâmetro`,
  'ObjectSearch.title.txt': () => `Pesquisa geográfica`,
  'ObjectSearch.pin.txt': () => `Afixar`,
  'ObjectSearch.unpin.txt': () => `Desafixar`,
  'MainSearchPanel.searchHints.txt': () => `Sugestões de Pesquisa`,
  'MainSearchPanel.searchResults.txt': () => `Resultados da Pesquisa`,
  'MainSearchPanel.features.txt': () => `Funcionalidades`,
  'MainSearchPanel.pin.txt': () => `Novo marcador`,
  'MainSearchPanel.pin.tooltip.txt': () => `Novo marcador`,
  'MainSearchPanel.route.txt': () => `Nova rota`,
  'MainSearchPanel.route.tooltip.txt': () => `Nova rota`,
  'MainSearchPanel.geographicArea.txt': () => `Nova área geográfica`,
  'MainSearchPanel.geographicArea.tooltip.txt': () => `Nova área geográfica`,
  'MainSearchPanel.newMyLocationPin.txt': () => `O meu marcador de localização`,
  'MainSearchPanel.myLocationPin.txt': () => `A minha localização`,
  'MainSearchPanel.show.txt': () => `Mostrar`,
  'MainSearchPanel.show.all.txt': () => `Mostrar tudo`,
  'MainSearchPanel.hide.txt': () => `Ocultar`,
  'MainSearchPanel.hide.all.txt': () => `Ocultar tudo`,
  'MainSearchPanel.delete.txt': () => `Eliminar`,
  'MainSearchPanel.delete.all.txt': () => `Eliminar tudo`,
  'MainSearchPanel.convert.txt': () => `Converter resultados de pesquisa em marcadores`,
  'MainSearchPanel.convert.all.txt': () => `Converter todos os resultados de pesquisa em marcadores`,
  'MainSearchPanel.showPinLabels.txt': () => `Mostrar etiquetas de marcadores`,
  'MainSearchPanel.close.label.txt': () => `Pesquisa geográfica`,
  'MainSearchPanel.navigate.tooltip.txt': () => `Mostrar detalhes`,
  'MainSearchPanel.demographics.tooltip.txt': () => `Dados Demográficos`,
  'PanelHeader.back.tooltip.txt': () => `Voltar`,
  'GeographicAreaPanel.title.txt': () => `Área Geográfica`,
  'GeographicAreaPanel.draw.txt': () => `Desenhar área`,
  'GeographicAreaPanel.update.txt': () => `Atualizar área`,
  'GeographicAreaPanel.label.txt': () => `Etiqueta:`,
  'GeographicAreaPanel.location.txt': () => `Localização:`,
  'GeographicAreaPanel.distance.miles.txt': () => `Distância (mi):`,
  'GeographicAreaPanel.distance.kilometer.txt': () => `Distância (km):`,
  'GeographicAreaPanel.distance.add.txt': () => `Adicionar distância`,
  'GeographicAreaPanel.time.add.txt': () => `Adicionar hora`,
  'GeographicAreaPanel.distance.delete.txt': () => `Eliminar distância`,
  'GeographicAreaPanel.time.minutes.txt': () => `Tempo (min):`,
  'GeographicAreaPanel.duration.txt': () => `Duração:`,
  'GeographicAreaPanel.distanceUnits.miles.txt': () => `Milhas`,
  'GeographicAreaPanel.distanceUnits.kilometers.txt': () => `Quilómetros`,
  'GeographicAreaPanel.menu.clear.txt': () => `Limpar área geográfica`,
  'GeographicAreaPanel.menu.link.txt': () => `Associar morada a elementos de dados e marcadores por predefinição`,
  'GeographicAreaPanel.menu.unlink.txt': () => `Desassociar morada de área geográfica`,
  'GeographicAreaPanel.menu.delete.txt': () => `Eliminar área geográfica`,
  'GeographicAreaPanel.demographics.txt': () => `Dados demográficos`,
  'GeographicAreaPanel.demographics.set.txt': () => `Mostrar dados demográficos`,
  'GeographicAreaPanel.demographics.menu.expand.txt': () => `Expandir vista`,
  'GeographicAreaPanel.demographics.menu.edit.txt': () => `Editar dados demográficos`,
  'GeographicAreaPanel.demographics.menu.delete.txt': () => `Eliminar dados demográficos`,
  'GeographicAreaPanel.demographics.expired.txt': () => `Os dados demográficos têm de ser recarregados`,
  'GeographicAreaPanel.demographics.reload.txt': () => `Recarregar dados demográficos`,
  'GeographicAreaPanel.invalid.location.txt': () => `A área geográfica não possui uma localização válida e não pode ser criada.`,
  'TravelTypeField.dateselector.tooltip.txt': () => `Selecione uma data e hora`,
  'TravelTypeField.cancel.txt': () => `Cancelar`,
  'TravelTypeField.ok.txt': () => `OK`,
  'TravelTypeField.button.tooltip.txt': () => `Selecione uma data e hora`,
  'TravelTypeField.day.txt': () => `Dia:`,
  'TravelTypeField.time.txt': () => `Hora:`,
  'TravelTypeField.distanceTypes.direct.txt': () => `Direto`,
  'TravelTypeField.distanceTypes.distance.txt': () => `Distância`,
  'TravelTypeField.travelType.txt': () => `Modo de deslocação:`,
  'TravelTypeField.traffic.txt': () => `Incluir trânsito:`,
  'TravelTypeField.traffic.offset.txt': () => `Desvio de tempo de trânsito:`,
  'TravelTypeField.traffic.daytime.txt': () => `Data e hora do trânsito:`,
  'TravelTypeField.distanceTypes.distance.unit.txt': () => `Unidade de distância`,
  'TravelTypeField.distanceTypes.driving.distance.txt': () => `Distância de condução`,
  'TravelTypeField.distanceTypes.driving.time.txt': () => `Tempo de condução`,
  'TravelTypeField.distanceTypes.trucking.distance.txt': () => `Distância de transporte rodoviário`,
  'TravelTypeField.distanceTypes.trucking.time.txt': () => `Tempo de transporte rodoviário`,
  'TravelTypeField.distanceTypes.walking.distance.txt': () => `Distância a pé`,
  'TravelTypeField.distanceTypes.walking.time.txt': () => `Tempo a pé`,
  'TravelTypeField.driveTimeTrafficTypes.none.txt': () => `Não`,
  'TravelTypeField.driveTimeTrafficTypes.live.txt': () => `Trânsito atual`,
  'TravelTypeField.driveTimeTrafficTypes.historic.txt': () => `Trânsito típico`,
  'TravelTypeField.driveTimeTraffic.offset.fmt': ({hour}) => `${hour} h`,
  'TravelTypeField.driveTimeTraffic.update.refresh.txt': () => `Atualizar trânsito para este funcionalidade`,
  'TravelTypeField.driveTimeTraffic.update.refreshAll.txt': () => `Atualizar trânsito para todas as funcionalidades`,
  'TravelTypeField.driveTimeTraffic.update.tooltip.txt': () => `Atualizar dados de trânsito`,
  'RoutePanel.title.txt': () => `Rota`,
  'RoutePanel.draw.txt': () => `Desenhar percurso`,
  'RoutePanel.update.txt': () => `Atualizar percurso`,
  'RoutePanel.label.txt': () => `Etiqueta:`,
  'RoutePanel.locations.txt': () => `Localizações`,
  'RoutePanel.menu.clear.txt': () => `Limpar rota`,
  'RoutePanel.menu.reverse.txt': () => `Inverter rota`,
  'RoutePanel.menu.add.waypoint.txt': () => `Adicionar localização de rota`,
  'RoutePanel.menu.delete.waypoint.txt': () => `Eliminar localização de rota`,
  'RoutePanel.menu.unlink.txt': () => `Desassociar localização de rota`,
  'RoutePanel.menu.arrows.txt': () => `Setas de rota`,
  'RoutePanel.menu.arrows.hide.txt': () => `Ocultar setas de rota`,
  'RoutePanel.menu.arrows.show.txt': () => `Mostrar setas de rota`,
  'RoutePanel.menu.arrows.oneway.txt': () => `Unidirecional`,
  'RoutePanel.menu.arrows.twoway.txt': () => `Bidirecional`,
  'RoutePanel.menu.delete.txt': () => `Eliminar rota`,
  'RoutePanel.route.width.txt': () => `Largura da rota`,
  'RoutePanel.distance.txt': () => `Distância:`,
  'RoutePanel.distance.miles.fmt': ({distance}) => `${distance} milhas`,
  'RoutePanel.distance.kilometers.fmt': ({distance}) => `${distance} km`,
  'RoutePanel.location.add.txt': () => `Adicionar localização`,
  'RoutePanel.location.delete.txt': () => `Eliminar localização`,
  'RoutePanel.duration.txt': () => `Hora:`,
  'RoutePanel.invalid.location.txt': () => `A rota não tem localizações válidas e não pode ser criada.`,
  'RoutePanel.accessibilityCellInfo.fmt': ({index, location}) => `Localização ${index}, ${location}, entrada`,
  'PinPanel.pinTitle.txt': () => `Afixar`,
  'PinPanel.addDescription.txt': () => `Adicionar descrição`,
  'PinPanel.deleteDescription.txt': () => `Eliminar descrição`,
  'PinPanel.newPin.txt': () => `Novo marcador nesta localização`,
  'PinPanel.deletePin.txt': () => `Eliminar marcador`,
  'PinPanel.linkPins.txt': () => `Associar marcadores a elementos de dados por predefinição`,
  'PinPanel.unlinkAllItems.txt': () => `Desassociar todos os itens`,
  'PinPanel.unlinkItems.txt': () => `Desassociar itens`,
  'PinPanel.label.txt': () => `Etiqueta:`,
  'PinPanel.location.txt': () => `Localização:`,
  'PinPanel.description.txt': () => `Descrição:`,
  'PinPanel.linked.txt': () => `ASSOCIADO`,
  'PinPanel.searchClickPlaceholder.txt': () => `Pesquisar ou selecionar no mapa`,
  'PinPanel.searchPlaceholder.txt': () => `Pesquisar`,
  'PinPanel.addRoute.txt': () => `Adicionar rota`,
  'PinPanel.addRoute.tooltip.txt': () => `Adicionar rota`,
  'PinPanel.addArea.txt': () => `Adicionar área geográfica`,
  'PinPanel.addArea.tooltip.txt': () => `Adicionar área geográfica`,
  'PinPanel.addArea.title.txt': () => `Adicionar Área Geográfica`,
  'PinPanel.myLocationTitle.txt': () => `O Meu Marcador de Localização`,
  'PinPanel.deleteMyLocationPin.txt': () => `Eliminar O Meu Marcador de Localização`,
  'PinPanel.enableAutoUpdate.txt': () => `Ativar atualização automática de A Minha Localização`,
  'PinPanel.disableAutoUpdate.txt': () => `Desativar atualização automática de A Minha Localização`,
  'PinPanel.editAutoRefreshInterval.txt': () => `Editar intervalo de atualização automática de A Minha Localização...`,
  'PinPanel.linkToPin.txt': () => `Associar a marcador`,
  'PinPanel.useCurrentLocation.txt': () => `Usar localização atual do marcador`,
  'PinPanel.notDrawn.txt': () => `Não desenhado`,
  'PinPanel.undetermined.txt': () => `Indeterminado`,
  'PinPanel.findMyLocation.txt': () => `Localizar A Minha Localização`,
  'PinPanel.cannotDetermineLocation.txt': () => `A aplicação não consegue determinar a sua localização atual. Se pretender partilhar a sua localização, consulte a ajuda do seu browser ou dispositivo.`,
  'PinPanel.autoRefreshInterval.txt': () => `Intervalo de Atualização Automática de A Minha Localização...`,
  'PinPanel.interval.hours.txt': () => `Horas:`,
  'PinPanel.interval.minutes.txt': () => `Minutos:`,
  'PinPanel.interval.seconds.txt': () => `Segundos:`,
  'PinPanel.invalid.location.txt': () => `O marcador não possui uma localização válida e não pode ser criado.`,
  'PinPanel.description.miles.1.fmt': ({value1}) => `${value1} milhas`,
  'PinPanel.description.miles.2.fmt': ({value1, value2}) => `${value1}; ${value2} milhas`,
  'PinPanel.description.miles.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} milhas`,
  'PinPanel.description.kilometers.1.fmt': ({value1}) => `${value1} km`,
  'PinPanel.description.kilometers.2.fmt': ({value1, value2}) => `${value1}; ${value2} km`,
  'PinPanel.description.kilometers.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} km`,
  'PinPanel.description.minutes.1.fmt': ({value1}) => `${value1} min.`,
  'PinPanel.description.minutes.2.fmt': ({value1, value2}) => `${value1}; ${value2} min.`,
  'PinPanel.description.minutes.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} min.`,
  'PinPanel.clearLocation.tooltip.txt': () => `Limpar texto de localização`,
  'DiscardChangesDialog.title.area.txt': () => `Área geográfica`,
  'DiscardChangesDialog.title.route.txt': () => `Rota`,
  'DiscardChangesDialog.text.area.txt': ({label}) => `Foram efetuadas alterações à área geográfica, mas a área não foi redesenhada.\n\nPretende eliminar as alterações a ${label}?`,
  'DiscardChangesDialog.text.route.txt': ({label}) => `Foram efetuadas alterações à rota geográfica, mas a rota não foi redesenhada.\n\nPretende eliminar as alterações a ${label}?`,
  'DiscardChangesDialog.discard.txt': () => `Eliminar`,
  'DiscardChangesDialog.cancel.txt': () => `Cancelar`,
  'FeatureErrorDialog.title.area.txt': () => `Desenhar Área Geográfica`,
  'FeatureErrorDialog.title.route.txt': () => `Desenhar Itinerário`,
  'FeatureErrorDialog.text.area.txt': () => `Não foi possível desenhar a área geográfica...\n\nSugestão: Se a localização da sua área não contiver infraestruturas de viagem, como estradas, poderá não ser possível calcular uma área geográfica. Em vez disso, utilize um tipo de deslocação à distância ou desloque a área para uma localização que disponha de infraestruturas de viagem.`,
  'FeatureErrorDialog.text.route.txt': () => `Não foi possível desenhar o itinerário...\n\nSugestão: Se a localização do seu percurso não contiver infraestruturas de viagem, como estradas, poderá não ser possível calcular um itinerário. Em vez disso, utilize um tipo de viagem à distância ou desloque o itinerário para uma localização que disponha de infraestruturas de viagem.`,
  'FeatureErrorDialog.close.txt': () => `Fechar`,
  'DemographicsSelectorDialog.title.txt': () => `Mostrar Dados Demográficos`,
  'DemographicsSelectorDialog.cancel.txt': () => `Cancelar`,
  'DemographicsSelectorDialog.ok.txt': () => `OK`,
  'DemographicsSelectorDialog.country.txt': () => `País/Região`,
  'DemographicsSelectorDialog.tab.basic.txt': () => `Básico`,
  'DemographicsSelectorDialog.tab.advanced.txt': () => `Avançado`,
  'DemographicsSelectorDialog.tab.recent.txt': () => `Recentes`,
  'DemographicsSelectorDialog.categories.txt': () => `Categorias`,
  'DemographicsSelectorDialog.category.income.txt': () => `Rendimento`,
  'DemographicsSelectorDialog.category.age.txt': () => `Idade`,
  'DemographicsSelectorDialog.category.households.txt': () => `Fogos`,
  'DemographicsSelectorDialog.category.housing.txt': () => `Habitação`,
  'DemographicsSelectorDialog.category.maritalstatus.txt': () => `Estado Civil`,
  'DemographicsSelectorDialog.category.population.txt': () => `População`,
  'DemographicsSelectorDialog.category.usergroup.txt': () => `Grupo de utilizadores`,
  'DemographicsSelectorDialog.category.health.txt': () => `Saúde`,
  'DemographicsSelectorDialog.category.education.txt': () => `Educação`,
  'DemographicsSelectorDialog.category.business.txt': () => `Negócio`,
  'DemographicsSelectorDialog.category.race.txt': () => `Etnia`,
  'DemographicsSelectorDialog.category.spending.txt': () => `Gastos`,
  'DemographicsSelectorDialog.category.behaviors.txt': () => `Comportamentos`,
  'DemographicsSelectorDialog.category.jobs.txt': () => `Tarefas`,
  'DemographicsSelectorDialog.category.poverty.txt': () => `Pobreza`,
  'DemographicsSelectorDialog.category.tapestry.txt': () => `Tapestry`,
  'DemographicsSelectorDialog.category.atrisk.txt': () => `Em Risco`,
  'DemographicsSelectorDialog.category.keyfacts.txt': () => `Factos Principais`,
  'DemographicsSelectorDialog.category.supplyanddemand.txt': () => `Oferta e Procura`,
  'DemographicsSelectorDialog.category.policy.txt': () => `Política`,
  'DemographicsSelectorDialog.category.landscape.txt': () => `Horizontal`,
  'DemographicsSelectorDialog.category.crime.txt': () => `Crime`,
  'ManageColumns.title.txt': () => `Gerir Colunas`,
  'ManageColumns.ok.txt': () => `OK`,
  'ManageColumns.cancel.txt': () => `Cancelar`,
  'ManageColumns.hiddenColumns.txt': () => `Colunas ocultas`,
  'ManageColumns.displayedColumns.txt': () => `Colunas apresentadas`,
  'SearchResultPanel.title.txt': () => `Resultado de Pesquisa`,
  'SearchResultPanel.menu.delete.txt': () => `Eliminar resultado de pesquisa`,
  'SearchResultPanel.convert.txt': () => `Converter em marcador`,
  'SearchResultPanel.convert.tooltip.txt': () => `Converter em marcador`,
  'DemographicsResultsDialog.title.txt': () => `Dados demográficos`,
  'DemographicsResultsDialog.cancel.txt': () => `Cancelar`,
  'DemographicsResultsDialog.close.txt': () => `Fechar`,
  'DemographicsResultsDialog.edit.txt': () => `Editar`,
  'DemographicsResultsDialog.layout.page.txt': () => `Vista de carrossel`,
  'DemographicsResultsDialog.layout.list.txt': () => `Vista de coluna individual`,
  'DemographicsResultsDialog.layout.tile.txt': () => `Vista de mosaicos`,
  'DemographicsResultsDialog.noData.txt': () => `Não existem dados que correspondam à área geográfica atual.`,
  'PinsAtSameLocationPanel.title.txt': () => `Marcadores na Mesma Localização`,
  'PinsAtSameLocationPanel.searchResults.txt': () => `RESULTADOS DA PESQUISA`,
  'PinsAtSameLocationPanel.pins.txt': () => `MARCADORES`,
  'PinsAtSameLocationPanel.showAll.txt': () => `Mostrar tudo`,
  'PinsAtSameLocationPanel.hideAll.txt': () => `Ocultar tudo`,
  'PinsAtSameLocationPanel.deleteAll.txt': () => `Eliminar tudo`,
  'PinsAtSameLocationPanel.show.txt': () => `Mostrar`,
  'PinsAtSameLocationPanel.hide.txt': () => `Ocultar`,
  'PinsAtSameLocationPanel.delete.txt': () => `Eliminar`,
  'LocationPopover.pin.title.txt': () => `Localização do Marcador`,
  'LocationPopover.area.title.txt': () => `Localização da área geográfica`,
  'LocationPopover.route.title.txt': ({label}) => `Localização da rota ${label}`,
  'LocationPopover.name.txt': () => `Nome`,
  'LocationPopover.location.txt': () => `Localização:`,
  'LocationPopover.ok.txt': () => `Definir localização`,
  'LocationPopover.cancel.txt': () => `Sair do modo de seleção`,
  'LocationPopover.hint.txt': () => `Clicar novamente no mapa para identificar uma localização diferente.`,
  'TreeDualSelector.source.default.txt': () => `Itens disponíveis`,
  'TreeDualSelector.target.default.txt': () => `Itens selecionados`,
  'TreeDualSelector.filtered.length.fmt': ({label, filteredLength, totalLength}) => `${label} (${filteredLength} de ${totalLength}):`,
  'TreeDualSelector.item.length.fmt': ({label, length}) => `${label} (${length}):`,
  'TreeDualSelector.emptymessage.txt': () => `Sem itens`,
  'TreeDualSelector.filter.placeholder.txt': () => `Filtro`,
  'TreeDualSelector.customItem.choiceIcon.tooltip.txt': () => `Item personalizado`,
  'TreeDualSelector.afterAction.add.fmt': ({noOfSelectedRows}) => `${noOfSelectedRows} itens adicionados`,
  'TreeDualSelector.afterAction.remove.fmt': ({noOfSelectedRows}) => `${noOfSelectedRows} itens removidos`,
  'TreeDualSelector.afterAction.addAll.txt': () => `Todos os itens são adicionados`,
  'TreeDualSelector.afterAction.removeAll.txt': () => `Todos os itens são removidos`,
  'TreeDualSelector.afterAction.up.txt': () => `Movido para cima`,
  'TreeDualSelector.afterAction.down.txt': () => `Movido para baixo`,
  'TreeDualSelector.afterAction.top.txt': () => `Movido para o início`,
  'TreeDualSelector.afterAction.bottom.txt': () => `Movido para o fim`,
  'TreeDualSelector.afterAction.undo.add.txt': () => `Ação de adicionar revertida`,
  'TreeDualSelector.afterAction.undo.remove.txt': () => `Ação de remover revertida`,
  'TreeDualSelector.afterAction.customAdd.txt': () => `item personalizado adicionado`,
  'TreeDualSelector.customItemSelection.fmt': ({customItemSelected}) => `${customItemSelected} item personalizado selecionado`,
  'TreeDualSelector.itemSelectionWithDescription.fmt': ({itemSelected, itemDescription}) => `${itemSelected} ${itemDescription} selecionado`,
  'TreeDualSelector.itemSelection.fmt': ({itemSelected}) => `${itemSelected} selecionados`,
  'TreeDualSelector.reorderButton.up.button.aria': ({targetListLabel}) => `Mover uma linha para cima em ${targetListLabel}`,
  'TreeDualSelector.reorderButton.down.button.aria': ({targetListLabel}) => `Mover uma linha para baixo em ${targetListLabel}`,
  'TreeDualSelector.reorderButton.top.button.aria': ({targetListLabel}) => `Mover para o topo de ${targetListLabel}`,
  'TreeDualSelector.reorderButton.bottom.button.aria': ({targetListLabel}) => `Mover para o fundo de ${targetListLabel}`,
  'TreeDualSelector.moveButton.add.button.aria': ({targetListLabel}) => `Adicionar item a ${targetListLabel}`,
  'TreeDualSelector.moveButton.addall.button.aria': ({targetListLabel}) => `Adicionar todos a ${targetListLabel}`,
  'TreeDualSelector.moveButton.remove.button.aria': ({targetListLabel}) => `Remover item de ${targetListLabel}`,
  'TreeDualSelector.moveButton.removeall.button.aria': ({targetListLabel}) => `Remover todos de ${targetListLabel}`,
  'TreeDualSelector.moveButton.undoadd.button.aria': ({targetListLabel}) => `Anular adicionar para ${targetListLabel}`,
  'TreeDualSelector.moveButton.undoremove.button.aria': ({targetListLabel}) => `Anular remover para ${targetListLabel}`,
  'TreeDualSelector.searchField.aria': ({listLabel}) => `Filtrar ${listLabel}`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.title': () => `Remover`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.txt': () => `Quaisquer itens personalizados que tenha selecionado para remoção serão eliminados definitivamente se continuar.\n\n Pretende continuar?`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.title': () => `Remover Todos os Itens`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.txt': () => `Os itens personalizados nesta lista serão definitivamente eliminados se continuar.\n\n Pretende continuar?`,
  'LinkNavigator.backButton.label': () => `Voltar`,
  'LinkNavigator.rootOrReportLinkBreadcrumb.label': ({reportLabel, sectionLabel}) => `${reportLabel}: ${sectionLabel}`,
  'LinkNavigator.incomingFilters.title': () => `Filtros de Entrada`,
  'LinkNavigator.reportLevel.label': () => `Nível de relatório`,
  'LinkNavigator.sectionLevel.label': () => `Nível de página`,
  'ReportSectionZeroState.heading.label': () => `Conceber Relatório`,
  'ReportSectionZeroState.description.label': () => `Arraste objetos ou itens de dados para a página, ou selecione uma opção abaixo.`,
  'ReportSectionZeroState.hideAutoChartButton.description.label': () => `Arraste objetos ou itens de dados para a página, ou comece a partir de um template de página.`,
  'ReportSectionZeroState.autoChartButton.label': () => `Gerar objeto`,
  'ReportSectionZeroState.selectTemplateButton.label': () => `Selecione um template`,
  'ReportSectionZeroState.exploreSuggestions.label': () => `Explorar sugestões`,
  'PromptContainerTooltip.noSelections.txt': () => `Nada selecionado`,
  'PromptContainerTooltip.selectedValues.txt': () => `Valores Selecionados`,
}
export default localizers;
